<template>
  <b-modal
    id="client-switch-prompt-modal"
    :visible="show"
    @hidden="hideEvents"
    title="Switch Client?"
    centered
    no-close-on-backdrop
    no-close-on-esc
    modal-class="client-switch-modal"
  >
    <p class="mb-3">The page you're trying to view belongs to another client.</p>

    <div class="d-flex align-items-center justify-content-between p-3 bg-light rounded">
      <div class="text-center flex-grow-1">
        <small class="text-muted d-block mb-1">Current Client</small>
        <strong>{{ currentClientName }}</strong>
      </div>
      <div class="px-4">
        <font-awesome-icon :icon="['far', 'arrow-right']" class="text-muted" size="lg" />
      </div>
      <div class="text-center flex-grow-1">
        <small class="text-muted d-block mb-1">Switch To</small>
        <strong>{{ targetClientName }}</strong>
      </div>
    </div>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="handleCancel" :disabled="loading">
        Cancel
      </b-button>
      <b-button variant="primary" @click="handleConfirm" :disabled="loading">
        <b-spinner v-if="loading" small class="mr-1" />
        Switch Client
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ModalMixin from '@/components/Modal/ModalMixin';

export default {
  name: 'ClientSwitchPromptModal',
  mixins: [ModalMixin],
  props: {
    currentClientName: {
      type: String,
      required: true,
    },
    targetClientName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalId: 'client-switch-prompt-modal',
    };
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
      this.hideModal();
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    hideModalEvents() {
      // Required by ModalMixin
    },
  },
};
</script>

<style lang="scss">
#client-switch-prompt-modal {
  .modal-dialog {
    min-height: 250px;
  }

  .modal-content {
    min-height: 250px;
  }
}
</style>
